import React from "react";
import { SvgData } from "../../model/SvgData";
import { ModuleContainerGeneric } from "../ModuleContainerGeneric";
import { IconoItem } from "./IconoItem";
import { GenericComponentProps } from "../../model/GenericComponentProps";
import { Titulo } from "./Titulo";
import { HStack } from "@bpba/ui-components";
import { BP_MAX_WIDTH } from "../../constants/data";

export const IconosStatic = (props: GenericComponentProps<SvgData>) => {
  const defaultBackgroundColor = "secondary.0";

  return (
    <ModuleContainerGeneric
      display={"flex"}
      flexDirection={"column"}
      paddingX={[0, null, null, null, 107]}
      maxWidth={[null, null, null, BP_MAX_WIDTH]}
      backgroundColor={props.backgroundColor || defaultBackgroundColor}
    >
      {props.moduloTitulo && (
        <Titulo isStatic={true}>{props.moduloTitulo}</Titulo>
      )}
      <HStack justifyContent={"space-around"}>
        {props.data?.map((item: SvgData, index: number) => (
          <IconoItem data={item} key={index} />
        ))}
      </HStack>
    </ModuleContainerGeneric>
  );
};
